<h2 mat-dialog-title>Switch user</h2>
<mat-divider></mat-divider>
<mat-dialog-content>
  <div [formGroup]="form" fxLayout="column" fxLayoutGap="10px">
    <div fxLayout fxLayoutGap="10px" class="person">
      <fl-employee-autocomplete
        formControlName="employeeId"
        [allCompanies]="true"
      ></fl-employee-autocomplete>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    (click)="submit()"
    [disabled]="form.invalid"
    mat-raised-button
    class="e2e-close-card-ok"
    color="primary"
  >
    Switch
  </button>
  <button mat-button [mat-dialog-close]="true" autofocuss>Cancel</button>
</mat-dialog-actions>
